var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    className: "notification-icon-bell",
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1V2C1 2.79565 1.31607 3.55871 1.87868 4.12132C2.44129 4.68393 3.20435 5 4 5C4.79565 5 5.55871 4.68393 6.12132 4.12132C6.68393 3.55871 7 2.79565 7 2V1",
    stroke: "#79310E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBottom);
export default __webpack_public_path__ + "static/media/notificationBottom.e470b6bbf1c53c27613414ccde46a141.svg";
export { ForwardRef as ReactComponent };